// Форма слова «час» в родительном падеже: «в течение 1 часа», «в течение 2 часов».
export const getHoursLabel = (count: number): string =>
  count % 10 === 1 && count % 100 !== 11 ? 'часа' : 'часов';
